
import { combineReducers } from "redux"
import {PageReduser} from "../pages/Reduser/PageReduser"

const Rootreduser = combineReducers ({PageReduser:PageReduser})
 



export default Rootreduser